import { ContentItem } from "../ContentItem/ContentItem";
import { ContentParent } from "../ContentParent";
import { Translate } from "components/common/Translate/Translate";
import { EasyToUseIcon } from "components/common/Icons/EasyToUseIcon";
import { PerfectQualityIcon } from "components/common/Icons/PerfectQualityIcon";
import { ImageFormatsIcon } from "components/common/Icons/ImageFormatsIcon";
import { PrivacyGuaranteedIcon } from "components/common/Icons/PrivacyGuaranteedIcon";
import { HeartIcon } from "components/common/Icons/HeartIcon";
import { Route } from "lucide-react";

export const CropperContent = () => {
    return (
        <ContentParent>
            <ContentItem
                title={<Translate keyName="content-easy-title" />}
                description={<Translate keyName="content-easy-sub-title" />}
                icon={<EasyToUseIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-size-title" />}
                description={<Translate keyName="content-size-sub-title" />}
                icon={<PerfectQualityIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-ratio-title" />}
                description={<Translate keyName="content-ratio-sub-title" />}
                icon={<ImageFormatsIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-privacy-title" />}
                description={<Translate keyName="content-privacy-sub-title" />}
                icon={<PrivacyGuaranteedIcon />}
            />
            <ContentItem
                title={<Translate keyName="content-online-title" />}
                description={<Translate keyName="content-online-sub-title" />}
                icon={<Route width={30} height={30} />}
            />
            <ContentItem
                title={<Translate keyName="content-free-title" />}
                description={<Translate keyName="content-free-sub-title" />}
                icon={<HeartIcon />}
            />
        </ContentParent>
    );
};
